module.exports = __webpack_public_path__ + "img/e1fd62b2e78fe2d207ead2d0da09dd25.png";